import { render, staticRenderFns } from "./Bilancio.vue?vue&type=template&id=dae6484c&scoped=true&"
import script from "./Bilancio.vue?vue&type=script&lang=js&"
export * from "./Bilancio.vue?vue&type=script&lang=js&"
import style0 from "./Bilancio.vue?vue&type=style&index=0&id=dae6484c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae6484c",
  null
  
)

export default component.exports